import propTypes from 'prop-types'
import React from 'react'
import Results from './Results'
import Table from '../Table'
import ButtonCSV from './ButtonCSV'

const fields = [
  {
    name: 'Order ID',
    field: ['order_id'],
    link: 'order_id',
    linkEndpoint: '/orders'
  },
  { name: 'POS Order ID', field: ['local_id'] },
  {
    name: 'Date & Time',
    field: ['created_at'],
    format: 'datetimeZoned',
    tz: 'timezone'
  },
  {
    name: 'Cashier',
    field: ['employee'],
    link: 'employee_id',
    linkEndpoint: '/employees'
  },
  { name: 'Timeclock ID', field: ['timeclock_id'] },
  { name: 'POS Terminal', field: ['terminal'] },
  { name: 'Service Type', field: ['service_type'], format: 'enum' },
  {
    name: 'Amount',
    field: ['amount'],
    format: 'dollars'
  }
]

// const makeTotals = data => {
//   if (!data || !data.length) return null
//   const amount = data.reduce((t, i) => (t += parseFloat(i.amount)), 0.0)
//   return {
//     order_id: 'Totals',
//     local_id: ' ',
//     created_at: ' ',
//     employee: ' ',
//     timeclock_id: ' ',
//     terminal: ' ',
//     service_type: ' ',
//     amount: amount
//   }
// }

const Voids = ({ data, handlers }) => {
  // const totals = makeTotals(data)
  // const tableData = totals ? [...data, totals] : [...data]
  return (
    <>
      <div className="report__actions">
        <div className="report__actions__container">
          <div className="report__actions__left">
            <Results data={data} {...handlers} />
          </div>
          <div className="report__actions__right">
            <ButtonCSV endpoint="/reporting/refunds/csv" />
          </div>
        </div>
      </div>
      <div className="report__table">
        <Table fields={fields} items={data} />
      </div>
    </>
  )
}

Voids.displayName = 'Voids'
Voids.propTypes = {
  data: propTypes.array,
  handlers: propTypes.object
}

export default Voids
